<form-field [formGroup]="fieldConfig.formGroup"
            [options]="fieldConfig"
            [isFull]="isFull"
            [ngClass]='{
                fielConfigClassName: true,
                "single-selection": maxSelection == 1
            }'>
    <div class="field">
        <fa-icon *ngIf="fieldConfig.iconDefinition" [icon]="fieldConfig.iconDefinition" class="field-icon"></fa-icon>
        <p-multiSelect #multiSelect
                       [tabindex]="fieldConfig.tabindex || null"
                       [showHeader]="showHeader"
                       [filter]="!useApi"
                       [appendTo]="appendTo"
                       [options]="getOptions()"
                       [panelStyle]="config.panelStyle"
                       [defaultLabel]="config.defaultLabel"
                       [displaySelectedLabel]="config.displaySelectedLabel"
                       [formControlName]="fieldConfig.formControlName"
                       [selectedItemsLabel]="selectedItemsLabel"
                       [class.full]="isFull"
                       [class.positionFixed]="isPositionFixed"
                       [class.has-icon]="fieldConfig.iconDefinition"
                       [showToggleAll]="!maxSelection"
                       (keydown)="navigate($event)"
                       (onChange)="handleChange($event, action.click)"
                       (onPanelShow)="showPanel()"
                       (onPanelHide)="handleChange($event, action.close)"
                       (onFocus)="multiSelect.show()">
            <ng-template pTemplate="header" *ngIf="useApi">
                <text #searchField
                      [fieldConfig]="{formGroup: apiGroup, formControlName: 'apiQuery'}"
                      [textFormat]="'uppercase'"
                      [focusOnMe]="true"
                      [autocomplete]="'off'"
                      (keydown)="navigateSearchField($event)"
                      class="api-field"></text>
            </ng-template>
            <ng-template let-option pTemplate="item" let-i="index">
                <div #optionItem
                     class="optionItem e2e-status-{{option.value}}"
                     (mouseenter)="removeFocusClass(i)"
                     (click)="focusFilterInput()"
                     [class.focus-option]="selectedId === i"
                     [class.is-child]="option.isChild"
                     [class.isSelected]="option.value | isChecked:selectedOptions:selected:mustEmitChangeOnHide">
                    <div *ngIf="option.faIcon">
                        <fa-icon [icon]="option.faIcon"></fa-icon>
                    </div>
                    <div class="text-content">
                        <div>
                            {{option.label}}
                        </div>
                        <div *ngIf="option.secondLine" class="second-line">
                            {{option.secondLine}}
                        </div>
                    </div>

                </div>
            </ng-template>
        </p-multiSelect>
    </div>
</form-field>
